export default function getBreadCrumbs(location) {
  return location.pathname.split("/").filter(item => item)
}
